<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">New Article</p>
    </header>
    <section class="modal-card-body">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <b-notification
          @close="resetErrors"
          :active="newArticleErrors != null"
          type="is-danger"
          has-icon
          aria-close-label="Close notification"
          role="alert"
        >
          {{ newArticleErrors }}
        </b-notification>

        <b-steps :hasNavigation="false" v-model="activeStep">
          <!--   Topics    -->
          <b-step-item step="1" label="Topic">
            <h1 class="title is-size-4 has-text-centered">
              Choose the Topic your article will be about
            </h1>
            <h2 class="subtitle is-size-6 has-text-centered">
              Selecting the most relevant topic will help users find your article more
              easily.
            </h2>
            <div class="columns is-multiline">
              <div class="column has-text-centered">
                <div class="box fullheightcustom is-primary">
                  <div class="p-3">
                    <b-button
                      :type="{ 'is-success': article.article_topic_id === 1 }"
                      size="is-medium"
                      :rounded="true"
                      @click="setArticleTopic(1)"
                    >
                      <article-topic-icon :articleTopic="'Photography'" />
                      <span>Photography</span>
                    </b-button>
                  </div>
                  <p class="has-text-dark">
                    This article is about <b>photography</b> and <b>films</b>.<br />
                    <span class="is-italic"
                      >Examples: How to deal with luminosity, find the right
                      places...</span
                    >
                  </p>
                </div>
              </div>
              <div class="column has-text-centered">
                <div class="box fullheightcustom is-primary">
                  <div class="p-3">
                    <b-button
                      :type="{ 'is-success': article.article_topic_id === 2 }"
                      size="is-medium"
                      :rounded="true"
                      @click="setArticleTopic(2)"
                    >
                      <article-topic-icon :articleTopic="'Posing'" />
                      <span>Posing</span>
                    </b-button>
                  </div>
                  <p class="has-text-dark">
                    This article is about taking good <b>poses</b> for pictures.<br />
                    <span class="is-italic"
                      >Examples: How to train for poses, posing during
                      conventions...</span
                    >
                  </p>
                </div>
              </div>

              <div class="column has-text-centered">
                <div class="box fullheight is-primary">
                  <div class="p-3">
                    <b-button
                      :type="{ 'is-success': article.article_topic_id === 3 }"
                      size="is-medium"
                      :rounded="true"
                      @click="setArticleTopic(3)"
                    >
                      <article-topic-icon :articleTopic="'Make-up'" />
                      <span>Make-up</span>
                    </b-button>
                  </div>
                  <p class="has-text-dark">
                    This article is about tips regarding <b>make-up</b> in general.<br />
                    <span class="is-italic"
                      >Examples: How to choose your make-up, tips to keep your make-up all
                      day long...</span
                    >
                  </p>
                </div>
              </div>

              <div class="column has-text-centered">
                <div class="box fullheight is-primary">
                  <div class="p-3">
                    <b-button
                      :type="{ 'is-success': article.article_topic_id === 4 }"
                      size="is-medium"
                      :rounded="true"
                      @click="setArticleTopic(4)"
                    >
                      <article-topic-icon :articleTopic="'Crafting'" />
                      <span>Crafting</span>
                    </b-button>
                  </div>
                  <p class="has-text-dark">
                    This article is about <b>crafting</b> any kind of item.<br />
                    <span class="is-italic"
                      >Examples: Difference between fabrics, how to use Worbla...</span
                    >
                  </p>
                </div>
              </div>

              <div class="column has-text-centered">
                <div class="box fullheight is-primary">
                  <div class="p-3">
                    <b-button
                      :type="{ 'is-success': article.article_topic_id === 5 }"
                      size="is-medium"
                      :rounded="true"
                      @click="setArticleTopic(5)"
                    >
                      <article-topic-icon :articleTopic="'Contest'" />
                      <span>Contest</span>
                    </b-button>
                  </div>
                  <p class="has-text-dark">
                    This article is about <b>Cosplay contests</b>.<br />
                    <span class="is-italic"
                      >Examples: Prepare for your first contest, tips on
                      performance...</span
                    >
                  </p>
                </div>
              </div>

              <div class="column has-text-centered">
                <div class="box ffullheightcustom is-primary">
                  <div class="p-3">
                    <b-button
                      :type="{ 'is-success': article.article_topic_id === 6 }"
                      size="is-medium"
                      :rounded="true"
                      @click="setArticleTopic(6)"
                    >
                      <article-topic-icon :articleTopic="'Convention'" />
                      <span>Convention</span>
                    </b-button>
                  </div>
                  <p class="has-text-dark">
                    This article is about <b>Conventions</b>.<br />
                    <span class="is-italic"
                      >Examples: Surviving to conventions, making friends at
                      conventions...</span
                    >
                  </p>
                </div>
              </div>

              <div class="column has-text-centered">
                <div class="box fullheightcustom is-primary">
                  <div class="p-3">
                    <b-button
                      :type="{ 'is-success': article.article_topic_id === 7 }"
                      size="is-medium"
                      :rounded="true"
                      @click="setArticleTopic(7)"
                    >
                      <article-topic-icon :articleTopic="'Guest & Pro'" />
                      <span>Guest & Pro</span>
                    </b-button>
                  </div>
                  <p class="has-text-dark">
                    This article is for tips and tricks from Cosplayers who
                    <b>make money</b> out of cosplaying.<br />
                    <span class="is-italic"
                      >Examples: How to become a Guest, how to do commissions...</span
                    >
                  </p>
                </div>
              </div>

              <div class="column has-text-centered">
                <div class="box fullheightcustom is-primary">
                  <div class="p-3">
                    <b-button
                      :type="{ 'is-success': article.article_topic_id === 8 }"
                      size="is-medium"
                      :rounded="true"
                      @click="setArticleTopic(8)"
                    >
                      <article-topic-icon :articleTopic="'Body Positivity'" />
                      <span>Body Positivity</span>
                    </b-button>
                  </div>
                  <p class="has-text-dark">
                    This article is about <b>Body positivity</b> and acceptance.<br />
                    <span class="is-italic"
                      >Examples: Genderbender, how to react to body shaming, skin color in
                      Cosplay...</span
                    >
                  </p>
                </div>
              </div>

              <div class="column has-text-centered">
                <div class="box fullheightcustom is-primary">
                  <div class="p-3">
                    <b-button
                      :type="{ 'is-success': article.article_topic_id === 9 }"
                      size="is-medium"
                      :rounded="true"
                      @click="setArticleTopic(9)"
                    >
                      <article-topic-icon :articleTopic="'Social Networks'" />
                      <span>Social Networks</span>
                    </b-button>
                  </div>
                  <p class="has-text-dark">
                    This article is about <b>promoting</b> your creations through
                    <b>Social Networks</b>.<br />
                    <span class="is-italic"
                      >Examples: How to get visibility, improving your posts
                      content...</span
                    >
                  </p>
                </div>
              </div>

              <div class="column has-text-centered">
                <div class="box fullheightcustom is-primary">
                  <div class="p-3">
                    <b-button
                      :type="{ 'is-success': article.article_topic_id === 10 }"
                      size="is-medium"
                      :rounded="true"
                      @click="setArticleTopic(10)"
                    >
                      <article-topic-icon :articleTopic="'Other'" />
                      <span>Other</span>
                    </b-button>
                  </div>
                  <p class="has-text-dark">
                    This article Topic<b>
                      is not correctly represented in previous sections.</b
                    ><br />
                    <span class="is-italic"
                      >Examples: Please note that categorizing properly increases
                      visibility in search results.</span
                    >
                  </p>
                </div>
              </div>
            </div>
          </b-step-item>

          <!--    Details    -->

          <b-step-item step="2" label="Details">
            <h1 class="title is-size-4 has-text-centered">
              More details about your new Article
            </h1>
            <h2 class="subtitle is-size-6 has-text-centered">
              Fill in the details so that users know what this article is about.
            </h2>

            <item-title
              :title="article.title"
              :itemType="'article'"
              :displaySuccess="false"
              @updateTitle="article.title = $event"
            />

            <b-field>
              <template slot="label">
                Subtitle
                <b-tooltip
                  position="is-right"
                  type="is-dark"
                  multilined
                  size="is-small"
                  label="A one-line sentence which gives more input on the content of the Article"
                >
                  <b-icon
                    type="is-gray"
                    size="is-small"
                    icon="help-circle-outline"
                  ></b-icon>
                </b-tooltip>
              </template>

              <b-input
                placeholder="e.g. Taking the right angles and training your facial expressions to get perfect photoshoots at conventions."
                v-model="article.subtitle"
                maxlength="100"
                type="textarea"
              ></b-input>
            </b-field>

            <item-languages
              :languages="article.language_list"
              :maxTags="'1'"
              @updateLanguages="article.language_list = $event"
            />

            <item-video :video="article.video" @updateVideo="article.video = $event" />

            <item-tags
              :tags="article.tag_list"
              :placeholder="'WCS, Comic Con, Photoshop...'"
              @updateTags="article.tag_list = $event"
            />

            <item-visibility
              :hidden="article.hidden"
              :itemType="'article'"
              @updateHidden="article.hidden = $event"
            />
          </b-step-item>
        </b-steps>
      </ValidationObserver>
    </section>

    <footer class="modal-card-foot">
      <span class="card-footer-item">
        <b-button
          @click="previousStep"
          :disabled="onFirstStep"
          type="is-danger"
          icon-left="skip-previous"
        >
          Previous
        </b-button>
      </span>

      <span class="card-footer-item">
        <b-button
          @click="nextStep"
          v-if="!onLastStep"
          :disabled="article.article_topic_id == null"
          type="is-success"
          icon-right="skip-next"
        >
          Next
        </b-button>

        <b-button @click="createArticle" v-else type="is-success" icon-right="check">
          Create
        </b-button>
      </span>

      <span class="card-footer-item">
        <b-button @click="$parent.close()"> Close </b-button>
      </span>
    </footer>
  </div>
</template>

<script>
import ArticleTopicIcon from '@/views/Article/ArticleTopicIcon.vue'
import { ValidationObserver } from 'vee-validate'

// Attributes
import ItemTitle from '@/components/Attributes/ItemTitle'
import ItemLanguages from '@/components/Attributes/ItemLanguages'
import ItemVideo from '@/components/Attributes/ItemVideo'
import ItemTags from '@/components/Attributes/ItemTags'
import ItemVisibility from '@/components/Attributes/ItemVisibility'

export default {
  data () {
    return {
      article: {
        title: null,
        subtitle: null,
        article_topic_id: null,
        tag_list: [],
        hidden: true,
        language_list: []
      },
      newArticleErrors: null,
      articleTopics: [],
      activeStep: 0,
      steps: 2
    }
  },
  components: {
    ArticleTopicIcon,
    ValidationObserver,
    ItemTitle,
    ItemLanguages,
    ItemVideo,
    ItemTags,
    ItemVisibility
  },
  computed: {
    onFirstStep () {
      return this.activeStep === 0
    },
    onLastStep () {
      return this.activeStep === this.steps - 1
    }
  },
  methods: {
    createArticle () {
      this.$refs.observer.validate().then((success) => {
        if (success) {
          this.$store
            .dispatch('articles/create', this.article)
            .then((resp) => {
              this.$router.push(`/articles/${resp.data.data.id}`)
            })
            .catch((error) => {
              console.log(error.response)
              this.newCraftErrors = error.response
            })
        }
      })
    },
    resetErrors () {
      this.newCraftErrors = null
    },
    previousStep () {
      let newStep = this.activeStep - 1
      this.activeStep = newStep > 0 ? newStep : 0
      this.resetErrors()
    },
    nextStep () {
      let newStep = this.activeStep + 1
      this.activeStep = newStep < this.steps - 1 ? newStep : this.steps - 1
      this.resetErrors()
    },
    setArticleTopic (topicId) {
      this.article.article_topic_id = topicId
    }
  },
  created () {
    this.$store
      .dispatch('articleTopics/index')
      .then((response) => {
        this.articleTopics = response.data.data
      })
      .catch((error) => {
        console.log(error.response)
      })
  }
}
</script>
